import { useState } from 'react'
import { Truck } from 'lucide-react'
import { ApiError, login } from '@/lib/api'
import { useSession } from '@/lib/session'
import { Button } from '@/components/ui/button'
import { Card, CardBody } from '@/components/ui/card'
import { Field } from '@/components/ui/field'

export function LoginPage() {
  const { refresh } = useSession()
  const [form, setForm] = useState({ email: '', password: '' })
  const [fields, setFields] = useState<Record<string, string>>({})
  const [message, setMessage] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit() {
    setBusy(true)
    setMessage(null)
    setFields({})
    try {
      await login(form)
      await refresh()
    } catch (err) {
      if (err instanceof ApiError) {
        setMessage(err.message)
        if (err.fields) setFields(err.fields)
      } else {
        setMessage(err instanceof Error ? err.message : 'Error desconocido')
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-sm flex-col justify-center px-4">
      <div className="mb-6 flex flex-col items-center gap-3 text-center">
        <span className="grid size-12 place-items-center rounded-2xl bg-primary text-primary-foreground">
          <Truck className="size-6" aria-hidden />
        </span>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">FleetOps</h1>
          <p className="text-sm text-muted-foreground">Entra para gestionar la flota</p>
        </div>
      </div>

      <Card>
        <CardBody>
          <form
            className="space-y-4"
            onSubmit={(e) => {
              e.preventDefault()
              void submit()
            }}
          >
            <Field
              label="Correo"
              required
              type="email"
              autoComplete="username"
              value={form.email}
              error={fields.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            />
            <Field
              label="Contraseña"
              required
              type="password"
              autoComplete="current-password"
              value={form.password}
              error={fields.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            />

            {message && (
              <p role="alert" className="rounded-lg bg-danger-muted px-3 py-2 text-sm font-medium text-[oklch(40%_0.19_27)]">
                {message}
              </p>
            )}

            <Button type="submit" className="w-full" loading={busy}>
              Iniciar sesión
            </Button>
          </form>
        </CardBody>
      </Card>
    </div>
  )
}
